import React, { FC, useCallback, useRef } from "react";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import useScrollDir from "../../hooks/useScrollDir";
import DesktopMenuGender from "./DesktopMenuGender";
import Breadcrumb from "../../components/Navigational/Breadcrumbs/Breadcrumb";
import BreadcrumbItem from "../../components/Navigational/Breadcrumbs/BreadcrumbItem";
import PageTitle from "../../components/DataDisplay/PageTitle/PageTitle";
import FilterButton from "../../components/ActionsSelectors/FilterButton/FilterButton";
import DesktopFiltersTop from "../Filters/DesktopFilters/DesktopFiltersTop";
import Divider from "../../components/DataDisplay/Divider/Divider";

const DesktopMenuWithFilters: FC = () => {
  const dir = useScrollDir();

  const { viewportWidth } = useWindowDimensions();

  /** Force rerender hack */
  const [, updateState] = React.useState<Record<string, unknown>>();

  const headingRef = useRef<HTMLDivElement>(null);

  const HEADING_HEIGHT = headingRef?.current?.offsetHeight || 68;

  const MENU_HEIGHT = 52;
  const FILTERS_HEIGHT = viewportWidth > 992 ? HEADING_HEIGHT : 0;

  const forceUpdate = React.useCallback(() => updateState({}), []);

  const handleEnded = useCallback(() => {
    setTimeout(forceUpdate);
  }, [forceUpdate]);

  return (
    <>
      <DesktopMenuGender />

      <div className="container-fluid">
        <Breadcrumb
          backLink={{ text: "back", href: "/" }}
          mobileBackLink={{ text: "shoes", href: "/" }}
        >
          <BreadcrumbItem text="Home" href="/" />
          <BreadcrumbItem text="Men" />
          <BreadcrumbItem text="Shoes" />
          <BreadcrumbItem active text="Last no link" />
        </Breadcrumb>
      </div>

      <div className="plp-heading plp-heading--with-tags">
        <div className="plp-heading--main-content">
          <div className="container-fluid">
            <PageTitle productCount={10904} title="Men's Running Shoes" />
            <FilterButton title="Sort & Filter" classes={{ root: "mb-6" }} />
          </div>
        </div>
      </div>

      <div
        ref={headingRef}
        className="plp-heading plp-heading--with-tags bg-color-white position-sticky header-padding-placeholder-filters"
        style={{ top: dir === "down" ? 0 : `${MENU_HEIGHT}px` }}
      >
        <div className="plp-heading--main-content">
          <div className="container-fluid">
            <div className="filter-and-sort-section">
              <DesktopFiltersTop
                onFiltersChange={forceUpdate}
                onClearAll={forceUpdate}
                onAnimationEnded={handleEnded}
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className="header-padding-placeholder-divider container-fluid bg-color-transparent position-sticky"
        style={{
          top:
            dir === "down"
              ? `${FILTERS_HEIGHT}px`
              : `${MENU_HEIGHT + FILTERS_HEIGHT}px`,
        }}
      >
        <Divider size="bold" />
      </div>
    </>
  );
};

export default DesktopMenuWithFilters;
